// src/utils/growthUtils.js

export const MAX_GROWTH_PCT = 300;

/**
 * 过滤 growth 极端值（避免折线图爆炸）
 * @param {number|null|undefined} g
 * @param {number} maxPct 默认 500%
 * @returns {number|null}
 */
export function sanitizeGrowth(g, maxPct = MAX_GROWTH_PCT) {
  if (g == null) return null;
  const v = Number(g);
  if (!isFinite(v)) return null;
  if (Math.abs(v) > maxPct) return null;
  return v;
}

/**
 * pivot 折线数据：把 yoy_table/mom_table 转成 recharts lineChart 可用格式
 * rows: [{ store, year/ym, growth }]
 */
export function pivotLinesByGrowth(rows, xField, maxPct = MAX_GROWTH_PCT) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return { data: [], keys: [], xKey: "x", domain: ["auto", "auto"] };
  }

  const xKeyName = xField === "year" ? "year" : "ym";

  const allX = Array.from(new Set(rows.map((r) => String(r[xKeyName])))).sort();
  const brands = Array.from(new Set(rows.map((r) => r.store))).sort();

  const map = new Map();
  for (const x of allX) map.set(x, { x });

  rows.forEach((r) => {
    const x = String(r[xKeyName]);
    const target = map.get(x);

    const g = (r.growth === 0 || r.growth) ? Number(r.growth) : null;
    target[r.store] = sanitizeGrowth(g, maxPct);
  });

  const data = Array.from(map.values());

  // domain 计算：用 5%~95% 分位数
  const vals = [];
  data.forEach((d) =>
    brands.forEach((b) => {
      if (d[b] === 0 || d[b]) vals.push(d[b]);
    })
  );

  let domain = ["auto", "auto"];
  if (vals.length > 2) {
    const sorted = vals.slice().sort((a, b) => a - b);

    const q = (p) => {
      const i = (sorted.length - 1) * p;
      const lo = Math.floor(i),
        hi = Math.ceil(i);
      if (lo === hi) return sorted[lo];
      return sorted[lo] + (sorted[hi] - sorted[lo]) * (i - lo);
    };

    const p5 = q(0.05);
    const p95 = q(0.95);

    domain = [Math.min(0, p5), Math.max(0, p95)];
  }

  return { data, keys: brands, xKey: "x", domain };
}
